import { UserSkill } from '@freelancer/datastore';
import { UserApi } from 'api-typings/users/users';

export function transformUserSkills(userApi: UserApi): UserSkill {
  return {
    id: userApi.id,
    skills: (userApi.jobs || []).map(job => job.id),
  };
}
